"use strict";
/* tslint:disable:max-line-length */
Object.defineProperty(exports, "__esModule", { value: true });
var service_definition_1 = require("./../services/service-definition");
var add_and_set_topic_request_serialiser_1 = require("./../services/topic-update/add-and-set-topic-request-serialiser");
var add_topic_result_serialiser_1 = require("./../services/topic-update/add-topic-result-serialiser");
var apply_json_patch_request_serialiser_1 = require("./../services/topic-update/apply-json-patch-request-serialiser");
var create_update_stream_and_set_request_serialiser_1 = require("./../services/topic-update/create-update-stream-and-set-request-serialiser");
var create_update_stream_request_serialiser_1 = require("./../services/topic-update/create-update-stream-request-serialiser");
var create_update_stream_response_serialiser_1 = require("./../services/topic-update/create-update-stream-response-serialiser");
var json_patch_result_serialiser_1 = require("./../services/topic-update/json-patch-result-serialiser");
var set_topic_request_serialiser_1 = require("./../services/topic-update/set-topic-request-serialiser");
var update_stream_add_topic_request_serialiser_1 = require("./../services/topic-update/update-stream-add-topic-request-serialiser");
var update_stream_add_topic_response_serialiser_1 = require("./../services/topic-update/update-stream-add-topic-response-serialiser");
var update_stream_id_serialiser_1 = require("./../services/topic-update/update-stream-id-serialiser");
var update_stream_request_serialiser_1 = require("./../services/topic-update/update-stream-request-serialiser");
exports.SET_TOPIC = {
    id: 118,
    request: set_topic_request_serialiser_1.SetTopicRequestSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.ADD_AND_SET_TOPIC = {
    id: 122,
    request: add_and_set_topic_request_serialiser_1.AddAndSetTopicRequestSerialiser,
    response: add_topic_result_serialiser_1.AddTopicResultSerialiser
};
exports.APPLY_JSON_PATCH = {
    id: 151,
    request: apply_json_patch_request_serialiser_1.ApplyJsonPatchRequestSerialiser,
    response: json_patch_result_serialiser_1.JsonPatchResultSerialiser
};
exports.CREATE_UPDATE_STREAM = {
    id: 125,
    request: create_update_stream_request_serialiser_1.CreateUpdateStreamRequestSerialiser,
    response: create_update_stream_response_serialiser_1.CreateUpdateStreamResponseSerialiser
};
exports.CREATE_UPDATE_STREAM_AND_SET = {
    id: 126,
    request: create_update_stream_and_set_request_serialiser_1.CreateUpdateStreamAndSetRequestSerialiser,
    response: create_update_stream_response_serialiser_1.CreateUpdateStreamResponseSerialiser
};
exports.CHECK_UPDATE_STREAM = {
    id: 127,
    request: update_stream_id_serialiser_1.UpdateStreamIdSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.STREAM_SET_TOPIC_SERVICE = {
    id: 128,
    request: update_stream_request_serialiser_1.UpdateStreamRequestSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.STREAM_APPLY_DELTA_SERVICE = {
    id: 129,
    request: update_stream_request_serialiser_1.UpdateStreamRequestSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.STREAM_ADD_TOPIC_SERVICE = {
    id: 130,
    request: update_stream_add_topic_request_serialiser_1.UpdateStreamAddTopicRequestSerialiser,
    response: update_stream_add_topic_response_serialiser_1.UpdateStreamAddTopicResponseSerialiser
};
exports.STREAM_ADD_AND_SET_TOPIC_SERVICE = {
    id: 131,
    request: add_and_set_topic_request_serialiser_1.AddAndSetTopicRequestSerialiser,
    response: update_stream_add_topic_response_serialiser_1.UpdateStreamAddTopicResponseSerialiser
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update-services.js
// module id = 1476
// module chunks = 0